import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import BlockSharpIcon from "@material-ui/icons/BlockSharp";
import BlockPopup from "./blockPopup";
import Utils from "../../../utility";
import { trendingHashtagsService } from "../../../services/index";
import Loader from "../../../common/components/tablesLoader";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    height: "783px",
    maxHeight: "783px",
    overflow: "scroll",
    marginBottom: "10px",
    overflowY: "scroll",
    overflowX: "hidden",
    "@media (min-width:960px) and (max-width:1200px)": {
      overflowX: "scroll",
    },
  },
  Card: {
    maxHeight: 100,
  },
});

export default function BasicTable() {
  const classes = useStyles();
  const preventDefault = (event) => event.preventDefault();
  const [trendingHashtags, settrendingHashtags] = React.useState([]);
  const [isLoading, setLoading] = React.useState(true);

  useEffect(() => {
    gettrendingHashtags();
  }, []);
  const gettrendingHashtags = async () => {
    let [error, Hashtags] = await Utils.parseResponse(
      trendingHashtagsService.gettrendingHashtags()
    );
    if (error || !Hashtags) return;
    settrendingHashtags(Hashtags);
    setLoading(false);
  };


  return (
    <Paper elevation={0} className={classes.root}>
      <Card elevation={0} className={classes.Card}>
        <Grid container spacing={1} style={{ height: 47 }}>
          <Grid item xs={3}>
            <Paper elevation={0} id="paper-top">
              <Link
                href="#"
                onClick={preventDefault}
                style={{ textDecoration: "none" }}
                id="top-seller"
              >
                Trending Hashtags
              </Link>
            </Paper>
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={3}>
            <Paper elevation={0} id="paper-view">
              <Link
                href="/home/hastag"
                style={{ textDecoration: "none" }}
                id="view-all"
              >
                View All
              </Link>
            </Paper>
          </Grid>
        </Grid>
      </Card>
      <Divider />
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" className="Table">
          <TableHead>
            <TableRow>
              <TableCell align="left" id="Table-cell" className="w-42">
                Hashtag Name
              </TableCell>
              <TableCell align="left" id="Table-cell" className="w-42">
                Videos Created
              </TableCell>
              <TableCell align="left" id="Table-cell" className="w-42">
                Block
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {isLoading ? (
              <TableRow>
                <TableCell style={{ border: "none" }} colspan={12}>
                  <div className="homePageLoader">
                  <Loader />
                  </div>
                </TableCell>
              </TableRow>
            ) : (trendingHashtags.length !== 0?
              trendingHashtags.map((row) => {
                if (row.isActive === true)
                  return (
                    <TableRow className="table-row">
                      <TableCell align="left" className="Table-cell">
                        {row.hashTag}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell"
                        style={{ width: 178 }}
                      >
                        {row.contentGroupsLength}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell"
                        style={{ width: 157 }}
                      >
                        <BlockPopup
                          row={row}
                          gettrendingHashtags={gettrendingHashtags}
                        />
                      </TableCell>
                    </TableRow>
                  );
              }):( <TableRow>
                <TableCell style={{ border: "none" }} colspan={12}>
                  <div className="homeSellBuyTable">
                    <center>No data found</center>
                  </div>
                </TableCell>
              </TableRow>)
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
